import {
    ICacheFactoryService,
    IHttpProvider,
    IHttpResponse,
    IQService,
    IRequestConfig,
    IRootScopeService
} from "angular";
import {AuthEvents} from "../../service/security/security-module";

export default function interceptors($httpProvider: IHttpProvider){
    $httpProvider.interceptors.push(cachingInterceptor);
}

const cachedPaths = ['/rest/contract/', '/datacatalog/featuretype/autocomplete'];
function isCachedPath(path: string) {
    for (let i = 0; i < cachedPaths.length; i++){
        if (path.indexOf(cachedPaths[i]) != -1) {
            return true;
        }
    }
    return false;
}

function cachingInterceptor($q: IQService, $cacheFactory: ICacheFactoryService, $rootScope: IRootScopeService, AUTH_EVENTS: AuthEvents) {
    const eTagCache = $cacheFactory('eTagCache');
    const objectCache = $cacheFactory('objectCache');

    $rootScope.$on(AUTH_EVENTS.AUTH_CHANGED, function() {
        eTagCache.removeAll();
    });

    return {
        request(config: IRequestConfig) {
            const url = config.url;
            if (!(config as any).force && isCachedPath(url)) {
                const cachedETag = eTagCache.get(url);
                if (cachedETag) {
                    config.headers['If-None-Match'] = cachedETag;
                }
            }
            return config;
        },
        response(response: IHttpResponse<any>) {
            const url = response.config.url;
            if (isCachedPath(url)) {
                const eTagHeader = response.headers('ETag');
                if (response.status === 200 && eTagHeader) {
                    eTagCache.put(url, eTagHeader);
                    objectCache.put(url, response.data);
                    return response;
                } else {
                    return response;
                }
            } else {
                return response;
            }
        },
        responseError(response: IHttpResponse<any>) {
            if (response.status === 304) {
                const url = response.config.url;
                response.data = objectCache.get(url);
                return response;
            } else {
                return $q.reject(response);
            }
        }
    };
}

interceptors.$inject = ['$httpProvider'];
cachingInterceptor.$inject = ['$q', '$cacheFactory', '$rootScope', 'AUTH_EVENTS'];
